import * as _ from 'lodash';
import { DatePipe } from '@angular/common';
import { GatesMonitorDto } from '../../data/models/dto/arrival/gates-monitor.dto';
import { GroupByDate } from '../../data/models/dto/arrival/group-history-by-date';
import { groupHistoryByDate } from '../utils/arrival/history.util';

export const groupGatesMonitorByDate = (history: GatesMonitorDto[]): GroupByDate[] => {
  const groupedHistory = _.groupBy(history, 'dtGroup')
  const historyGroupByDate: GroupByDate[] = []
  for (const key in groupedHistory) {
    let historyGroup: GroupByDate = {
      date: key,
      gatesMonitor: groupedHistory[key]
    }
    historyGroupByDate.push(historyGroup)
  }
  return historyGroupByDate
}

export const populateDtGroup = (responseHistories: GatesMonitorDto[], datePipe: DatePipe): GatesMonitorDto[] => {
  const monitorHistory: GatesMonitorDto[] = []
  responseHistories.forEach( history => {
    history.dtGroup = groupHistoryByDate(history.dtCreated, datePipe)
    monitorHistory.push(history)
  })
  return monitorHistory
}
